import { VictoryGroup, VictoryLine, VictoryScatter } from 'victory';
import { SingleDimensionInfo } from './lineGraph.types';

export const Line = ({
	filteredDimensionData,
	chartColor: { color, colorDarker, colorId, symbol },
}: SingleDimensionInfo) => {
	return (
		<VictoryGroup key={colorId} data={filteredDimensionData}>
			<VictoryLine
				name={`line-${colorId}`}
				key={`line-${colorId}`}
				style={{
					data: {
						strokeWidth: 2,
						strokeLinejoin: 'round',
						stroke: color,
					},
				}}
			/>
			<VictoryScatter
				name={`scatter-${colorId}`}
				key={`scatter-${colorId}`}
				size={3}
				symbol={symbol}
				style={{
					data: {
						fill: (data) => {
							return data.active ? colorDarker : color;
						},
					},
				}}
			/>
		</VictoryGroup>
	);
};
